// extracted by mini-css-extract-plugin
module.exports = {"cards":"MiniArchiveCards_cards__CC3gf","wrap":"MiniArchiveCards_wrap__KQ6U3"};